import * as React from 'react';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  root: {
    height: 50,
    borderTop: `1px solid ${theme.palette.line.main}`,
    backgroundColor: theme.palette.background.paper,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1200,
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
}));


/** 底部導航 */
export function Tabbar({content}) {

  const classes = useStyles();


  return (
    <Box
      className={classes.root}
      sx={{
        '& .Mui-selected': {
          fontSize: '0.75rem',
        },
      }}
    >
      {content}
    </Box>
  )
}